import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { useAuth } from '../contexts/AuthContext';

const STATUS_LABELS: Record<string, string> = {
  RASCUNHO: 'Rascunho', ENVIADO: 'Enviado', APROVADO: 'Aprovado',
  REJEITADO: 'Rejeitado', CANCELADO: 'Cancelado',
};

export default function DashboardPage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const { data: orcamentos = [] } = useQuery({
    queryKey: ['orcamentos-dashboard'],
    queryFn: () => api.get('/orcamentos').then(r => r.data),
  });

  const stats = {
    total: orcamentos.length,
    rascunho: orcamentos.filter((o: any) => o.status === 'RASCUNHO').length,
    enviado: orcamentos.filter((o: any) => o.status === 'ENVIADO').length,
    aprovado: orcamentos.filter((o: any) => o.status === 'APROVADO').length,
  };

  const recentes = orcamentos.slice(0, 5);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Olá, {user?.nome?.split(' ')[0]}!</h1>
          <p className="text-gray-500 text-sm">Bem-vindo ao sistema de orçamentos</p>
        </div>
        <button onClick={() => navigate('/orcamentos/novo')} className="btn-primary flex items-center gap-2">
          <span>+</span> Novo Orçamento
        </button>
      </div>

      {/* Cards de estatísticas */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {[
          { label: 'Total', value: stats.total, color: 'bg-blue-50 text-blue-700' },
          { label: 'Rascunhos', value: stats.rascunho, color: 'bg-gray-50 text-gray-700' },
          { label: 'Enviados', value: stats.enviado, color: 'bg-yellow-50 text-yellow-700' },
          { label: 'Aprovados', value: stats.aprovado, color: 'bg-green-50 text-green-700' },
        ].map(s => (
          <div key={s.label} className={`card text-center ${s.color}`}>
            <div className="text-3xl font-bold">{s.value}</div>
            <div className="text-sm font-medium mt-1">{s.label}</div>
          </div>
        ))}
      </div>

      {/* Orçamentos recentes */}
      <div className="card">
        <h2 className="font-semibold text-gray-900 mb-4">Orçamentos Recentes</h2>
        {recentes.length === 0 ? (
          <div className="text-center py-8 text-gray-400">
            <div className="text-4xl mb-2">📋</div>
            <p>Nenhum orçamento ainda</p>
            <button onClick={() => navigate('/orcamentos/novo')} className="btn-primary mt-4">
              Criar primeiro orçamento
            </button>
          </div>
        ) : (
          <div className="space-y-2">
            {recentes.map((o: any) => (
              <div
                key={o.id}
                onClick={() => navigate(`/orcamentos/${o.id}`)}
                className="flex items-center justify-between p-3 rounded-lg border border-gray-100 hover:bg-gray-50 cursor-pointer"
              >
                <div>
                  <span className="font-medium text-sm">{o.numero}</span>
                  <span className="text-gray-500 text-sm ml-2">{o.cliente?.nome}</span>
                </div>
                <span className={`text-xs px-2 py-1 rounded-full font-medium badge-${o.status.toLowerCase()}`}>
                  {STATUS_LABELS[o.status]}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
